export default __webpack_public_path__ + "static/media/img-0134-germany-full-face.664d8d35.png";